import { render, staticRenderFns } from "./DetailExpanse.vue?vue&type=template&id=f90ee8c8&scoped=true"
import script from "./DetailExpanse.vue?vue&type=script&lang=js"
export * from "./DetailExpanse.vue?vue&type=script&lang=js"
import style0 from "./DetailExpanse.vue?vue&type=style&index=0&id=f90ee8c8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f90ee8c8",
  null
  
)

export default component.exports